import React, { useState, useEffect } from 'react';
import { Chessboard } from 'react-chessboard';
import { Chess } from 'chess.js';
import Avatar from '@/assets/game-chess/Avatar.png';
import Avatar1 from '@/assets/game-chess/Avatar1.png';
import Coin from '@/assets/game-chess/Smiley-1.png';
import CountDown from './count-down';
import { useQuery } from '@tanstack/react-query';
function Playground() {
  const [game, setGame] = useState<any>();
  const [winner, setWinner] = useState<any>(null);
  const [gameOver, setGameOver] = useState(false);
  const [player1Time, setPlayer1Time] = useState(600);
  const [player2Time, setPlayer2Time] = useState(600);

  // Let's perform a function on the game state
  function safeGameMutate(modify: any) {
    setGame((g: any) => {
      const update = { ...g };
      console.log('g', g, update);
      console.log('modify', modify);
      modify(update);
      console.log('ssss', update);
      return update;
    });
  }

  // Movement of computer
  function makeRandomMove() {
    const possibleMove = game.moves();
    console.log('possibleMove', possibleMove);

    // exit if the game is over
    if (game?.isGameOver || game?.isDraw || possibleMove?.length === 0 || !possibleMove?.length) {
      console.log('GIANGG');
      setGameOver(true);
      const winner = game.turn() === 'w' ? 'Black' : 'White';
      setWinner(winner);

      return;
    }
    console.log('randommove', 123);
    // select random move
    const randomIndex = Math.floor(Math.random() * possibleMove.length);
    console.log('randommove', randomIndex);
    // play random move
    safeGameMutate((game: any) => {
      game.move(possibleMove[randomIndex]);
    });
  }

  // Perform an action when a piece is dropped by a user
  function onDrop(source: any, target: any) {
    if (gameOver) return false;

    let move = null;
    console.log('src', source, target);

    safeGameMutate((game: any) => {
      console.log('function () {}', game);
      move = game.move({
        from: source,
        to: target,
        promotion: 'q'
      });
    });

    console.log('move', move);
    // illegal move
    if (move === null) return false;
    // valid move
    return true;
  }

  // Reset the game
  function restartGame() {
    setGame(new Chess());
    setGameOver(false);
    setWinner(null);
    setPlayer1Time(600);
    setPlayer2Time(600);
  }

  // Listen for Enter key press to restart the game
  useEffect(() => {
    function handleKeyPress(event: any) {
      if (event.key === 'Enter') {
        restartGame();
      }
    }
    window.addEventListener('keydown', handleKeyPress);
    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, []);

  useQuery({
    queryKey: [`checkBlackTurn`],
    queryFn: () => {
      if (game?.turn() !== 'b') {
        return -1;
      }

      makeRandomMove();
      return -1;
    },
    retry: false,
    refetchInterval: 2500,
    enabled: game?.turn() === 'b'
  });

  return (
    <div className=' mt-[50px] w-full'>
      <div className=' w-full playground'>
        <div className='playground-after'></div>
        <div className='w-full flex gap-[66px] relative z-[2] playground-main   px-4 py-6'>
          <div className='player-1 flex-[0.25] flex flex-col items-start self-end gap-4'>
            <div className='w-full h-[1px] bg-[#3D3C43]'></div>
            <CountDown
              totalTime={player1Time}
              handleTotalTime={(time: number) => {
                setPlayer1Time(time);
              }}
              countdownID={1}
              time={999999999999}
              active={game?.turn() === 'w' && !gameOver}
            />
            <div className={`w-full bg-[#1C1C1E]  user-bg  relative ${game?.turn() === 'w' && 'active'}`}>
              <div className='user-bg-after'></div>
              <div className='w-full relative z-[2] flex gap-4 bg-[#1C1C1E] p-[10px]'>
                <img src={Avatar} className='w-12' alt='' />
                <div>
                  <span>yokoshima990</span>
                  <div className='flex items-center gap-1'>
                    <img src={Coin} className='w-[18px]' alt='' />
                    <span className='text-[#817D75]'>20 Coin</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='flex-[0.5] chessboard-container'>
            <div className='w-full'>
              <Chessboard
                position={game?.fen() || ''}
                onPieceDrop={onDrop}
                showBoardNotation={false}
                isDraggablePiece={() => game?.turn() === 'w'}
              />
              {!game && (
                <div
                  className='game-over cursor-pointer absolute z-[100] bg-gray-500 rounded-xl p-6 flex items-center justify-center flex-col top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2'
                  onClick={restartGame}
                >
                  <p>Click or Press Enter to Start</p>
                </div>
              )}
            </div>
          </div>
          <div className='player-1 flex-[0.25] flex flex-col items-start self-start gap-4'>
            <div className='w-full h-[1px] bg-[#3D3C43]'></div>
            <CountDown
              totalTime={player2Time}
              handleTotalTime={(time: number) => {
                setPlayer2Time(time);
              }}
              countdownID={2}
              time={999999999999}
              active={game?.turn() === 'b' && !gameOver}
            />
            <div className={`w-full bg-[#1C1C1E]  user-bg  relative ${game?.turn() === 'b' && 'active'}`}>
              <div className='user-bg-after'></div>
              <div className='w-full relative z-[2] flex gap-4 bg-[#1C1C1E] p-[10px]'>
                {' '}
                <img src={Avatar1} className='w-12' alt='' />
                <div>
                  <span>magnus_carlsen123</span>
                  <div className='flex items-center gap-1'>
                    <img src={Coin} className='w-[18px]' alt='' />
                    <span className='text-[#817D75]'>20 Coin</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {gameOver && (
          <div className='game-over absolute z-[100] bg-gray-500 rounded-xl p-6 flex items-center justify-center flex-col top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2'>
            <p>Game Over</p>
            <p>Winner: {winner}</p>
            <p>Press Enter to restart</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default Playground;
